import { required, minLength, maxLength, requiredIf } from 'vuelidate/lib/validators'

const maxArrayLength = (max) => value => Array.isArray(value) && value.length > 0 && value.length <= max

export default function complaintValidations() {
    return {
        complaint: {
            complaintProductionDepartmentId: {
                required: required
            },

            jobNumber: {
                required: required
            },

            discrepancyCatcherId: {
                required: required
            },

            complaintProductDescription: {
                required: required,
                minLength: minLength(3),
                maxLength: maxLength(1000)
            },

            responsiblePerson: {
                required: required,
                maxLength10: maxArrayLength(10)
            },

            errorCodeGroupId: {
                required: required
            },

            errorCodeId: {
                required: required
            },

            complaintWayOfProceeding: {
                complaintWayOfProceedingId: {
                    required: required
                },
                value: {
                    required: requiredIf(function requiredWhenAdjustment() {
                        return this.complaint.complaintWayOfProceeding.complaintWayOfProceedingId === this.PROCEEDING_TYPES.ADJUSTMENT
                    })
                }
            }
        }
    }
}
